import { render, staticRenderFns } from "./AddressSuggest.vue?vue&type=template&id=696ca84e&lang=pug&"
import script from "./AddressSuggest.vue?vue&type=script&lang=js&"
export * from "./AddressSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports